import { render, staticRenderFns } from "./PointOfSaleFormDrawer.vue?vue&type=template&id=04a5e666&scoped=true&"
import script from "./PointOfSaleFormDrawer.vue?vue&type=script&lang=js&"
export * from "./PointOfSaleFormDrawer.vue?vue&type=script&lang=js&"
import style0 from "./PointOfSaleFormDrawer.vue?vue&type=style&index=0&id=04a5e666&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a5e666",
  null
  
)

export default component.exports